import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@root/shared/services/api.service';
import { Urls } from '@root/utils/urls';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-blog-content',
  templateUrl: './blog-content.component.html',
  styleUrls: ['./blog-content.component.scss']
})
export class BlogContentComponent implements OnInit {
  blog: any;
  id: any;

  constructor(private route: ActivatedRoute, private apiService: ApiService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.route.paramMap.subscribe(paramMap => {
      this.id = paramMap.get('id') || '';
      this.getArticleByID()
    });
  }

  getArticleByID() {
    this.apiService.getData(`${Urls.getBlogDetailsById}?id=${this.id}`).subscribe(
      (response) => {
        this.blog = response.data
        if (this.blog.similarArticles && this.blog.similarArticles.length > 0) {
          this.blog.similarArticles = this.blog.similarArticles.slice(0, 3)
        }
      },
      (error) => this.toastr.error(error.errorMessage)
    );
  }

  redirectToSocialMedia(platform: string): void {
    let shareUrl = '';
    const message = 'Check out this amazing article!';
    const url = window.location.href;
    const encodedMessage = encodeURIComponent(message);
    const encodedURL = encodeURIComponent(url);
    switch (platform) {
      case 'facebook':
        // url = 'https://www.facebook.com/';
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}&quote=${encodedMessage}`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodedMessage}%20${encodedURL}`

        // url = 'https://web.whatsapp.com/';
        break;
      case 'twitter':
        // url = 'https://twitter.com/';
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedURL}`;
        break;
      case 'linkedin':
        // url = 'https://www.linkedin.com/';
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedURL}`;
        break;
      default:
        console.warn('Unsupported platform');
        return;
    }
    window.open(shareUrl, '_blank');
  }

  getArticle(id) {
    this.router.navigate(['/blogs/view', id]);
  }

}
